import React, { useState } from "react";
import Segmented from "@/components/Segmented";
import ScheduleBoardV2 from "../components/ScheduleBoardV2";
import ScheduleCalendar from "../components/ScheduleCalendar";
import { CalendarDays, LayoutGrid, CalendarRange } from "lucide-react";

export default function SchedulePage() {
  const [view, setView] = useState(() => localStorage.getItem("fieldops-schedule-view") || "board");
  const setViewPersist = (v) => {
    setView(v);
    localStorage.setItem("fieldops-schedule-view", v);
  };

  return (
    <div>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <Segmented
          options={[{ key: "board", label: "Board", icon: LayoutGrid, testId: "schedule-view-board" },
                    { key: "calendar", label: "Calendar", icon: CalendarRange,
                      testId: "schedule-view-calendar" }]}
          value={view}
          onChange={setViewPersist}
        />
      </div>
      {view === "calendar" ? <ScheduleCalendar /> : <ScheduleBoardV2 />}
    </div>
  );
}
